import BaseProductService from "@/modules/core/product/protected/BaseProductService";
import env from "environment";

class CreditAssignmentProductService extends BaseProductService {
  constructor() {
    super({
      baseUrl: env.baseUrl + "/credit-assignments/products"
    });
  }
}

const service = new CreditAssignmentProductService();

export default service;
